export const dynamicUiDefaultData = {
  TopImage: '',
  MiddleImage: '',
  UIType: '',
  UIData: '{}',
  ButtonMsgAfter: '',
  NotiContent: {
    Text: '',
    FontSize: '',
    FontColor: '',
  },
  FooterContent: '{}',
}
